import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { VideoArchiveTemplate } from "../video-archive-template";

const SessionsVideoArchivePage = (props) => {
    const collection = get(props, ["data", "collection"], {});
    return <VideoArchiveTemplate collection={collection} pageName="Sessions Video Archive" themeClass="sessions-theme" shouldApplyForumFilter={true} />;
};

SessionsVideoArchivePage.propTypes = {
    data: PropTypes.shape({
        collection: PropTypes.object
    })
};

export { SessionsVideoArchivePage };
